const announcerId = 'unionstack-live-region';
const notificationRegionId = 'unionstack-notifications';

function getAnnouncer() {
    let announcer = document.getElementById(announcerId);

    if (!announcer) {
        announcer = document.createElement('div');
        announcer.id = announcerId;
        announcer.className = 'us-visually-hidden-live';
        announcer.setAttribute('aria-live', 'polite');
        announcer.setAttribute('aria-atomic', 'true');
        document.body.append(announcer);
    }

    return announcer;
}

function announce(message, politeness = 'polite') {
    const announcer = getAnnouncer();
    announcer.setAttribute('aria-live', politeness);
    announcer.textContent = '';

    window.requestAnimationFrame(() => {
        announcer.textContent = message;
    });
}

function getNotificationRegion() {
    let region = document.getElementById(notificationRegionId);
    if (!region) {
        region = document.createElement('div');
        region.id = notificationRegionId;
        region.className = 'us-notifications';
        region.setAttribute('role', 'region');
        region.setAttribute('aria-label', window.UnionStackUi?.text?.notifications || globalThis.UnionStackI18n.text("Common.Notifications"));
        region.setAttribute('aria-live', 'polite');
        document.body.append(region);
    }
    return region;
}

function notify(message, options = {}) {
    if (!message) return null;
    const variant = ['danger', 'info', 'success', 'warning'].includes(options.variant) ? options.variant : 'info';
    const notification = document.createElement('div');
    notification.className = `us-notification us-notification--${variant}`;
    notification.setAttribute('role', variant === 'danger' ? 'alert' : 'status');
    const copy = document.createElement('div');
    copy.className = 'us-notification__copy';
    if (options.title) {
        const title = document.createElement('strong');
        title.className = 'us-notification__title';
        title.textContent = options.title;
        copy.append(title);
    }
    const body = document.createElement('span');
    body.textContent = message;
    copy.append(body);
    const dismiss = document.createElement('button');
    dismiss.className = 'us-notification__dismiss';
    dismiss.type = 'button';
    dismiss.setAttribute('aria-label', window.UnionStackUi?.text?.dismiss || globalThis.UnionStackI18n.text("Common.Dismiss"));
    dismiss.textContent = '×';
    const remove = () => notification.remove();
    dismiss.addEventListener('click', remove);
    notification.append(copy, dismiss);
    getNotificationRegion().append(notification);
    const timeout = Number.isFinite(options.timeout) ? options.timeout : 6000;
    if (timeout > 0) window.setTimeout(remove, timeout);
    return notification;
}

function setBusy(element, busy, message) {
    if (!(element instanceof HTMLElement)) {
        return;
    }

    element.dataset.usBusy = String(busy);
    element.setAttribute('aria-busy', String(busy));

    if (message) {
        announce(message);
    }
}

function focusFirstInvalid(form) {
    if (!(form instanceof HTMLFormElement)) {
        return false;
    }

    const invalidControl = form.querySelector(':invalid, .input-validation-error, [aria-invalid="true"]');

    if (!(invalidControl instanceof HTMLElement)) {
        return false;
    }

    invalidControl.focus({ preventScroll: true });
    invalidControl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return true;
}

function initializeValidationFocus() {
    document.addEventListener('invalid', (event) => {
        const form = event.target?.form;

        if (!(form instanceof HTMLFormElement) || form.dataset.usValidationFocusInitialized === 'true') {
            return;
        }

        form.dataset.usValidationFocusInitialized = 'true';
        window.requestAnimationFrame(() => focusFirstInvalid(form));
    }, true);
}

function initializeThemeColor() {
    const themeColor = document.querySelector('meta[name="theme-color"]');

    if (!themeColor) {
        return;
    }

    const update = () => {
        const canvas = getComputedStyle(document.documentElement).getPropertyValue('--us-canvas').trim();

        if (canvas) {
            themeColor.setAttribute('content', canvas);
        }
    };

    update();

    const observer = new MutationObserver(update);
    observer.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ['data-color'],
    });
}

function initialize() {
    document.documentElement.classList.add('us-js');
    getAnnouncer();
    initializeValidationFocus();
    initializeThemeColor();
}

const ui = Object.freeze({
    announce,
    focusFirstInvalid,
    initialize,
    notify,
    setBusy,
});

window.UnionStack = window.UnionStack || {};
window.UnionStack.ui = ui;

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
} else {
    initialize();
}

export { announce, focusFirstInvalid, initialize, notify, setBusy };
